import {OrganizationList, OrganizationRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {SoftChip, PersonAvatar, euros} from "../../../../components/kit";
import {Box, Stack, Typography} from "@mui/material";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";

export const OrganizationListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<OrganizationList> = {
        title: "Organizaciones",
        onClick: "/app/admin/marketing/organization",
        headers: [
            {title: "Nombre"},
            {title: "Actividad"},
            {title: "Email"},
            {title: "Web"},
        ],
        decorator: (bean: OrganizationList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
                    <Stack direction="row" spacing={1.5} alignItems="center" sx={{minWidth: 0}}>
                        <PersonAvatar name={bean.name} size={30}/>
                        <Typography variant="body2" fontWeight={600} noWrap>{bean.name}</Typography>
                    </Stack>
                </TableCell>
                <TableCell>{bean.mainActivity ?? "-"}</TableCell>
                <TableCell>{bean.email ?? "-"}</TableCell>
                <TableCell onClick={e => e.stopPropagation()}>
                    {bean.website
                        ? <Typography component="a" variant="body2" href={bean.website.startsWith("http") ? bean.website : "https://" + bean.website}
                                      target="_blank" rel="noopener" color="primary" noWrap sx={{display: "block"}}>
                            {bean.website.replace(/^https?:\/\//, "").replace(/\/$/, "")}
                        </Typography>
                        : "—"}
                </TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(OrganizationRestControllerApiFactory);
            // pageOrganization(page, size, sort, status, baja, term, showDismissed): status y baja
            // se colaron delante de term al añadirse a OrganizationFilters (#11784).
            return ctrl.pageOrganization(currentPage, size, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
